import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {getDefaultInfoStatus, setDefaultInfoStatus} from "../../utils/localStorage";
import {AuthenticationService} from "../../services/auth.service";
import {Router} from "@angular/router";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-default-info',
    templateUrl: './kaz-default-info.component.html',
    styleUrls: ['./kaz-default-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent]
})
export class KazDefaultInfoComponent implements OnInit {
  private _auth = inject(AuthenticationService);
  private _router = inject(Router);

  showDefaultInfo: boolean = false;

  ngOnInit() {
    this.show();
  }

  show() {
    if (!this._auth.isAuthenticated() && this._router.url === '/main') {
      this.showDefaultInfo = getDefaultInfoStatus();
    } else {
      this.showDefaultInfo = false;
    }
  }

  closeDefaultInfo() {
    //setDefaultInfoStatus(true); //TODO: soll nach zwei wochen wieder eingefügt werden
    this.showDefaultInfo = false;
  }
}
